const DoITCERDAS = () => {
  const videoSrc =
    "https://assets-us-01.kc-usercontent.com/a7507759-f4f5-0038-8fff-c1db251108c1/20981845-759f-4910-9503-e2b674dd5664/DoIT%20Cerdas%20Final.mp4";

  return (
    <div className="DoITCERDAS-wrapper">
      <div className="DoITCERDAS-container">
        <div className="DoITCERDAS-wordings">
          <p className="DoITCERDAS-title">AWALI dengan #DoITCERDAS</p>
          <p className="DoitCerdas-subtitle">
            Tempat belajar buat kamu jadi bisa cerdas atur keuangan dan buka
            berbagai peluang baru dalam hidup di era digital.
          </p>
        </div>
        <div className="DoITCERDAS-video-wrapper">
          <div className="DoITCERDAS-video-container">
            <video
              width="100%"
              height="100%"
              className="DoITCERDAS-video"
              controls
              autoPlay
              muted
            >
              <source src={videoSrc} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
      <style jsx>{`
        .DoITCERDAS-wrapper {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-bottom: 70px;
        }
        .DoITCERDAS-container {
          width: 100%;
          max-width: 960px;
          display: flex;
          flex-direction: column;
        }
        .DoITCERDAS-wordings {
          padding: 20px 16px;
        }
        .DoITCERDAS-title {
          font-size: 49px;
          font-weight: 900;
          margin: 0px;
        }
        .DoitCerdas-subtitle {
          font-weight: 400;
          font-size: 20px;
          margin: 0px;
          color: #666666;
        }

        .DoITCERDAS-video-wrapper {
          max-width: 100%;
          padding: 0 1.5rem;
        }

        .DoITCERDAS-video-container {
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
          overflow: hidden;
        }

        .DoITCERDAS-video {
          border: none;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          height: 100%;
          max-width: 100%;
        }

        @media only screen and (max-width: 700px) {
          .DoITCERDAS-wrapper {
            margin-bottom: 40px;
          }
          .DoITCERDAS-wordings {
            padding: 32px 16px 0px;
          }
          .DoITCERDAS-title {
            font-size: 24px;
            font-weight: 900;
            margin: 0px;
          }
          .DoitCerdas-subtitle {
            font-weight: 400;
            font-size: 18px;
            margin: 0px;
          }
          .DoITCERDAS-video-wrapper {
            max-width: 100%;
            padding: 1.5rem;
          }
        }
      `}</style>
    </div>
  );
};

export default DoITCERDAS;
